<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'app',
        data () {
            return {
                //isLogin: true,
            }
        },
        created () {

        },
        methods: {

        }
    }
</script>




// WEBPACK FOOTER //
// App.vue?4a1cc024